import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">关于香蕉影视</h2>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-10">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500 flex-shrink-0">
              <i className="ri-play-circle-fill text-background-50 text-2xl"></i>
            </div>
            <div>
              <h3 className="font-heading text-xl font-bold text-foreground-900">{aboutData.title}</h3>
              <p className="text-foreground-500 text-sm">全国领先的综艺娱乐免费高清在线观看平台</p>
            </div>
          </div>

          <div className="space-y-4">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">{aboutData.desc1}</p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">{aboutData.desc2}</p>
          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {[
              { num: '800万+', label: '活跃用户' },
              { num: '10万+', label: '高清片源' },
              { num: '50+', label: '每日更新' },
              { num: '99.9%', label: '可用率' },
            ].map((item, i) => (
              <div key={i} className="text-center p-4 rounded-lg bg-background-100">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">{item.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}